// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"298":"67aa0966ac66eacf","365":"604b3ab9e2866a98","384":"4142cae0ba55f85b","821":"87b492c0f81d54e3"}[chunkId] + ".js";
};